import { useQuery } from '@tanstack/react-query';
import { procurementService } from '../../services/procurement.service';
import { queryKeys } from '../../lib/query-keys';

export function useInventoryItems(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.inventoryItems.all(orgId ?? ''),
    queryFn: () => procurementService.getInventoryItemsBackend(orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
  });
}

export function useWarehouses(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.warehouses.all(orgId ?? ''),
    queryFn: () => procurementService.getWarehousesBackend(orgId!),
    enabled: !!orgId,
    staleTime: 5 * 60_000,
  });
}

export function useWarehouseEnums() {
  return useQuery({
    queryKey: queryKeys.warehouses.enums(),
    queryFn: async () => {
      try {
        return await procurementService.getWarehouseEnums();
      } catch {
        return { warehouse_types: ['central', 'site_store', 'transit'] as const };
      }
    },
    staleTime: 24 * 60 * 60_000,
  });
}
